export const rowsPerPageOptions = [10, 25, 50, 100];
